<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="section white-panel pt24 pb8 mb16">
          <p class="text-center mb16"><img src="/lib/images/ic_done_1.svg" alt=""></p>
          <div v-if="!pitlock.start_at">
            <p class="fs20 font-weight-bold text-center line-height1_7 mt20 mb20">店舗からのお電話を<br>
            お待ち下さい。</p>
            <p class="fs14 font-weight-bold text-center mb20">ご来店日に関するご連絡をさせて頂きます。</p>
          </div>
          <div v-else>
            <p class="fs20 font-weight-bold text-center line-height1_7 mt20 mb20">お申し込みありがとうございました。<br>
            ご来店お待ちしております。</p>
          </div>
        </div>

        <div class="section white-panel pt24 pb8 mb16" v-if="pitlock.start_at">
          <div>
            <p class="fs14 font-weight-bold text-center mb10">ご来店日時</p>
            <p class="fs20 font-weight-bold text-center mb10">{{ userForYyyyMmDD }} {{ pitlockSlots.time.information.reception_hour }}</p>
            <p class="fs14 font-weight-bold text-center mb10">こちらは事前点検のお申し込みです。</p>
          </div>
        </div>

        <div class="section white-panel pt20 ml16 mr16">
          <p class="fs13 line-height1_6">機種変更や端末紛失の際は、車検をご予約のSSまで電話にてご連絡下さい。</p>
          <h2 class="fs13 font-weight-bold mb4">{{ ssInfo.ss_name }}</h2>
          <table class="table w100p fs14 line-height1_2">
            <tbody>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8 w25p">電話番号</th>
                <td class="va-top pt8 pl8"><a v-on:click="calling()" class="color-green2">{{ ssInfo.tel }}</a></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_weekday || ssInfo.opening_hours_saturday || ssInfo.opening_hours_sunday || ssInfo.opening_hours_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">営業時間</th>
                <td class="va-top pt8 pl8">
                  <template v-if="ssInfo.opening_hours_weekday">平日 {{ ssInfo.opening_hours_weekday }}<br></template>
                  <template v-if="ssInfo.opening_hours_saturday">土曜 {{ ssInfo.opening_hours_saturday }}<br></template>
                  <template v-if="ssInfo.opening_hours_sunday">日曜 {{ ssInfo.opening_hours_sunday }}<br></template>
                  <template v-if="ssInfo.opening_hours_holiday">祝日 {{ ssInfo.opening_hours_holiday }}</template></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_carcare">
                <th class="font-weight-normal color-font2 va-top pt8">カーケア<br>営業時間</th>
                <td class="va-top pt8 pl8">{{ ssInfo.opening_hours_carcare }}</td>
              </tr>
              <tr v-if="ssInfo.regular_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">定休日</th>
                <td class="va-top pt8 pl8">{{ ssInfo.regular_holiday }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section transparent-panel">
          <button v-on:click='inspectionTopPage(nativeData, versionData)' class="button fs16 mt8 mb16 pd16 radius200 w80p">コミっと車検トップに戻る</button>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  computed: {
    userForYyyyMmDD () {
      if (!this.pitlockCalendar.day.information.dayYyyyMmdd) return null
      return moment(this.pitlockCalendar.day.information.dayYyyyMmdd).format('YYYY年MM月DD日')
    }
  },
  methods: {
    eventTrackStartCarcare () {
      this.nativeEVENTSet('ShakenKanryouButton', 'MOVED_CARCARE', 'TAP')
    },
    calling () {
      this.nativeEVENTSet('ShakenKanryouButton', 'TEL_BUTTON', 'TAP')
      window.location.href = 'tel:' + this.ssInfo.tel
    },
    inspectionTopPage (nativeData, versionData) {
      this.eventTrackStartCarcare()
      this.$router.push({
        name: 'InspectionTopV2',
        query: {
          tsid: nativeData.tsid,
          popinfoid: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion
        }
      })
    }
  },
  props: [
    'ssInfo',
    'nativeData',
    'versionData',
    'pitlock',
    'pitlockCalendar',
    'pitlockSlots'
  ],
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    this.nativePVset('SHAKEN_YOYAKU_KANRYOU')
  }
}
</script>
